export default __webpack_public_path__ + "static/media/NHL2020.ea6376dd.jpg";